module.exports = __webpack_public_path__ + "img/bg_rhombus3.8141ba5a.png";